import { useEffect, useState } from 'react';

import { getStorage } from '~/src/common/storage';

import { ARTICLES_VIEWED_STORAGE_KEY } from './constants';

type ActivePromoKey = 'promote-book' | 'paywall';

const MAX_NUMBER_OF_ARTICLES = 3;

export function useActivePromoKey({ url_title }: { url_title: string }): {
  activePromoKey: ActivePromoKey;
} {
  const storage = getStorage();

  const [articlesViewed, setArticlesViewed] = useState(
    storage.getItem(ARTICLES_VIEWED_STORAGE_KEY) ?? [],
  );

  useEffect(() => {
    const isAlreadyViewdArticle = articlesViewed.includes(url_title);
    if (!isAlreadyViewdArticle && articlesViewed.length <= MAX_NUMBER_OF_ARTICLES) {
      const nextViewedArticles = [...articlesViewed, url_title];

      storage.setItem(ARTICLES_VIEWED_STORAGE_KEY, nextViewedArticles);
      setArticlesViewed(nextViewedArticles);
    }
  }, [articlesViewed, storage, url_title]);

  // Ebook pop-up email capture appears during their first three articles (Paywall occurs on forth article visit)
  return {
    activePromoKey: articlesViewed.length > MAX_NUMBER_OF_ARTICLES ? 'paywall' : 'promote-book',
  };
}
